var _defs, _polygon, _g, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarshipAtlas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f2eb00;\n      }\n\n      .cls-2 {\n        fill: #e2e2e2;\n      }\n\n      .cls-3 {\n        fill: #454545;\n      }\n\n      .cls-4, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-6 {\n        opacity: .15;\n      }\n\n      .cls-5 {\n        opacity: .3;\n      }\n\n      .cls-7 {\n        fill: #1e1e1e;\n      }\n\n      .cls-8 {\n        fill: #565656;\n      }\n\n      .cls-9 {\n        fill: #878787;\n      }\n\n      .cls-10 {\n        fill: #e8dc00;\n      }\n\n      .cls-11 {\n        fill: #333;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "442.7 312.32 413.7 316.32 408.7 302.32 413.7 288.32 442.7 293.32 450.7 302.32 442.7 312.32"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "497.27 309.53 281.82 310.94 281.82 282.22 497.27 301.9 497.27 309.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "272.48 337.31 162.48 326.22 162.48 306.62 272.48 306.62 272.48 337.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "290.6 313.62 162.48 313.62 135.7 265.32 290.6 279.95 286.6 290.47 286.6 305.62 290.6 313.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "165.08 382.3 135.87 374.76 135.87 339.39 165.08 331.85 165.08 382.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "162.48 393.22 162.48 373.22 639.48 373.22 602.17 380.23 162.48 393.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "263.27 434.22 191.48 434.22 191.48 373.22 274.48 373.22 263.27 434.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "227.23 434.22 191.48 434.22 191.48 373.22 234.48 373.22 227.23 434.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "305.48 432.22 131.7 441.32 162.48 401.22 334.7 395.32 305.48 432.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "640.48 373.22 162.48 373.22 162.48 317.22 589.48 353.22 640.48 373.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "401.48 373.22 162.48 373.22 162.48 317.22 486.48 344.22 401.48 373.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.48 355.22 395.48 355.22 442.48 340.22 162.48 317.22 162.48 355.22"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "305.7 432.32 131.14 440.49 145.7 423.32 315.7 418.32 305.7 432.32"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "497.7 305.32 286.7 290.32 289.7 283.32 411.51 294.45 413.7 288.32 442.53 293.01 446.54 297.65 497.7 302.32 497.7 305.32"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "287.7 287.32 140.7 274.32 135.7 265.32 290.7 280.32 287.7 287.32"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "479.7 346.32 162.7 332.32 162.7 317.32 484.7 344.32 479.7 346.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarshipAtlas);
export default __webpack_public_path__ + "static/media/starship-atlas.aa22524b200b9ddf392e1343ddf3a12e.svg";
export { ForwardRef as ReactComponent };